import React, { Component } from 'react';
import { Container, Image } from 'react-bootstrap';
import './UnderConstruction.css';

class UnderConstruction extends Component {
  render() {
    return (
      <Container className='under-construction-controller'>
        <Image src={require('../assets/under-construction-banner.jpg')} className='under-construction-img' />
      </Container>
    );
  }
}

export default UnderConstruction;